/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('AvailableDayView',["$filter","DayData","DaySrv","DateSrv","HumanResourceData","AvailableDayHrView","AvailableDayPrView","Period",
        function ($filter,DayData,DaySrv,DateSrv,HumanResourceData,AvailableDayHrView,AvailableDayPrView,Period){
        //Special object fusion of Day and site->WorkingPeriodDay
        var AvailableDayView = function(day,dayIndex,aView) {
            this.ROUNDED_TIME_MINUTES = 15;
            this.dayIndex = dayIndex; // index of model day
            this.date = null;
            this.label = "";
            this.labelC = "";//label capitalized
            this.labelDayOfWC = "";  //Day of week capitalized
            this.labelDay = "";
            this.labelMonth = "";
            this.aView = aView;  //planningTable view
            this.aDayHrsView = [];
            this.aDayPrsView = [];
            this.globalATimesView = [];
            this.hasDiscount = false;
            // Times of a possible booking
            //              [    { period:
            //                    hrsView : []} // HrsView availables for booking
            //              ]
            this.aSlotsView = [];//lines of the planning (10h00,12h00,14h00 etcc.)
            //aSlotView = [ SLOT (13h00/14h00)
            //    {
            //        aTimesView :
            //              [ // Times of a possible booking
            //                  { period:
            //                    hrsView : [] }// HrsView availables for booking
            //              ],
            //         discount : 0
            //
            //    }

            var days = DayData.getActiveList();
            if (dayIndex!=-1) {
                this.date = DaySrv.getDateFromId(day.id);
                if (this.date)
                {
                    this.labelDay = $filter('date')(this.date, 'dd');//execute angular filter
                    this.labelMonth = $filter('date')(this.date, 'MM');//execute angular filter
                }
            }
            if (this.label.length>0)
                this.labelC = this.label.charAt(0).toUpperCase()+  this.label.substring(1);

            this.labelDayOfWC = $filter('date')(this.date, 'EEE');
            if (this.labelDayOfWC.length>0)
                this.labelDayOfWC = this.labelDayOfWC.charAt(0).toUpperCase()+  this.labelDayOfWC.substring(1,3);

            var dayHr = null;
            var hr = null
            var humanResourcesView = this.aView.domainView.getHumanResourcesView();
            for (var k = 0; k < humanResourcesView.length; k++) {
                dayHr = null;
                if (dayIndex !== undefined && dayIndex!=-1)
                {
                    hr = humanResourcesView[k].getModel();
                    if (hr && hr.hasPlanning)
                        dayHr = days[dayIndex].getDayHrByHrId(hr.id)
                    if (dayHr)
                        this.aDayHrsView.push(new AvailableDayHrView(dayHr,humanResourcesView[k],this))
                }
            }
            var dayPr = null;
            var pr = null
            var aDayPrView;
            var physicalResourcesView = this.aView.domainView.getPhysicalResourcesView();
            for (var k = 0; k < physicalResourcesView.length; k++) {
                pr = physicalResourcesView[k].getModel();
                if (pr && pr.number)
                {

                    for (var u=1; u <= pr.number; u++) {
                        dayPr = day.getDayPrByPrId(pr.id,u);
                        aDayPrView = new AvailableDayPrView(dayPr,physicalResourcesView[k],u,this);
                        this.aDayPrsView.push(aDayPrView);
                    }

                }
            }
            //init line period
            for (var j = 0; j < aView.aSlotsRefView.length; j++) {
                var slot =  {
                    aTimesView : [], //Time added
                    discount : 0
                    };

                this.aSlotsView.push(slot);
            }
        }
        AvailableDayView.prototype.getModel = function()
        {
            return DayData.getByIndex(this.dayIndex);
        }

        AvailableDayView.prototype.getPlgDayHrViewByHrId = function(hrId)
        {
            if (this.aDayHrsView)
                for (var k = 0; k < this.aDayHrsView.length; k++)
                    if (this.aDayHrsView[k].hrView)
                    {
                        var hr = this.aDayHrsView[k].hrView.getModel()
                        if (hr && hr.id == hrId)
                            return this.aDayHrsView[k];
                    }
            return null;

        }

        AvailableDayView.prototype.getADayHrsViewWithPeriod = function()
        {
            var aDayHrsViewWithPeriod = [];
            if (this.aDayHrsView)
                for (var k = 0; k < this.aDayHrsView.length; k++)
                    if (this.aDayHrsView[k].availablePeriods && this.aDayHrsView[k].availablePeriods.length>0)
                        aDayHrsViewWithPeriod.push(this.aDayHrsView[k]);
            return aDayHrsViewWithPeriod;

        }
        AvailableDayView.prototype.getADayPrsViewWithPeriod = function()
        {
            var aDayPrsViewWithPeriod = [];
            if (this.aDayPrsView)
                for (var k = 0; k < this.aDayPrsView.length; k++)
                    if (this.aDayPrsView[k].availablePeriods && this.aDayPrsView[k].availablePeriods.length>0)
                        aDayPrsViewWithPeriod.push(this.aDayPrsView[k]);
            return aDayPrsViewWithPeriod;

        }

        AvailableDayView.prototype.getDayHrView = function(hrView)
        {
            for (var k = 0; k < this.aDayHrsView.length; k++) {
                if (this.aDayHrsView[k].hrView===hrView)
                    return this.aDayHrsView[k];
            }
            //not found ? Create it?

            return null;
        }

        AvailableDayView.prototype.getDayPrView = function(prView)
        {
            for (var k = 0; k < this.aDayPrsView.length; k++) {
                if (this.aDayPrsView[k].prView===prView)
                    return this.aDayPrsView[k];
            }
            //not found ? Create it?

            return null;
        }
        AvailableDayView.prototype.addPeriodToGlobalATimesViewHr = function(period,hrView)
        {
            // check if exist.
            if (this.globalATimesView)
            {
                var alreadyExist = false;
                var i;
                for (i=0;i<this.globalATimesView.length && this.globalATimesView[i].period.start.getTime()<=period.start.getTime();i++)
                    if (this.globalATimesView[i].period.start.getTime()==period.start.getTime())
                        alreadyExist=true;

                if (alreadyExist)
                {
                    this.globalATimesView[i-1].hrsView.push(hrView);
                }
                else
                    if (i<this.globalATimesView.length)
                    {

                        if (this.aView.triesTime <= this.aView.triesTimeLimit && i>0 && ((period.start.getTime()-this.globalATimesView[i-1].period.start.getTime())<this.aView.triesTime)) // if try to insert a time close to previous one
                        {
                            if (period.start.getTime()%this.aView.triesTime ==0)    //check period is a product to this.aView.triesTime : periodic hours (every 15 minuts by example)
                            //replace  this.globalATimesView.
                            {
                                this.globalATimesView.splice(i-1,1,{
                                    period :period,
                                    hrsView : [hrView]
                                });
                                //check also next
                                if (i<this.globalATimesView.length && ((this.globalATimesView[i].period.start.getTime()-period.start.getTime())<this.aView.triesTime))
                                    this.globalATimesView.splice(i,1);//remove next if close
                            }
                            //else don't insert
                        }
                        else
                            if (this.aView.triesTime <= this.aView.triesTimeLimit && i<this.globalATimesView.length && ((this.globalATimesView[i].period.start.getTime()-period.start.getTime())<this.aView.triesTime))
                            // if try to insert a time close to next one
                            {
                                if (period.start.getTime()%this.aView.triesTime ==0)    //check period is a product to this.aView.triesTime:
                                //replace  this.globalATimesView.
                                    this.globalATimesView.splice(i,1,{
                                        period :period,
                                        hrsView : [hrView]
                                    });
                                //else don't insert
                            }
                            else //insert (not replace)
                                this.globalATimesView.splice(i,0,{
                                    period :period,
                                    hrsView : [hrView]
                                });

                    }
                    else
                    {
                        this.globalATimesView.push(
                        {
                            period :period,
                            hrsView : [hrView]
                        });
                    }
            }
        }
        AvailableDayView.prototype.addPeriodToGlobalATimesViewPr = function(period,prView)
        {
            // check if exist.
            if (this.globalATimesView)
            {
                var alreadyExist = false;
                var i;
                for (i=0;i<this.globalATimesView.length && this.globalATimesView[i].period.start.getTime()<=period.start.getTime();i++)
                    if (this.globalATimesView[i].period.start.getTime()==period.start.getTime())
                        alreadyExist=true;

                if (alreadyExist)
                {
                    this.globalATimesView[i-1].prsView.push(prView);
                }
                else
                if (i<this.globalATimesView.length)
                {

                    if (i>0 && ((period.start.getTime()-this.globalATimesView[i-1].period.start.getTime())<this.aView.triesTime)) // if try to insert a time close to previous one
                    {
                        if (period.start.getTime()%this.aView.triesTime ==0)    //check period is a product to this.aView.triesTime : periodic hours (every 15 minuts by example)
                        //replace  this.globalATimesView.
                        {
                            this.globalATimesView.splice(i-1,1,{
                                period :period,
                                prsView : [prView]
                            });
                            //check also next
                            if (i<this.globalATimesView.length && ((this.globalATimesView[i].period.start.getTime()-period.start.getTime())<this.aView.triesTime))
                                this.globalATimesView.splice(i,1);//remove next if close
                        }
                        //else don't insert
                    }
                    else
                        if (i<this.globalATimesView.length && ((this.globalATimesView[i].period.start.getTime()-period.start.getTime())<this.aView.triesTime))
                        // if try to insert a time close to next one
                        {
                            if (period.start.getTime()%this.aView.triesTime ==0)    //check period is a product to this.aView.triesTime:
                            //replace  this.globalATimesView.
                                this.globalATimesView.splice(i,1,{
                                    period :period,
                                    prsView : [prView]
                                });
                            //else don't insert
                        }
                        else //insert (not replace)
                            this.globalATimesView.splice(i,0,{
                                period :period,
                                prsView : [prView]
                            });

                }
                else
                {
                    this.globalATimesView.push(
                        {
                            period :period,
                            prsView : [prView]
                        });
                }
            }
        }


        AvailableDayView.prototype.updateAvailability = function(bookingView) {
            let hasAvailability = false;

            //Clear
            this.globalATimesView = [];
            bookingView.aDayView = this;//try this day

            var onlyPhysical = false;
            for (let i=0;i<bookingView.bookingServicesView.length && !onlyPhysical;i++)
                if  (bookingView.bookingServicesView[i].serviceView.nbPrsNeeded>0)
                    onlyPhysical = true;
            if (onlyPhysical)
                for (let i=0;i<bookingView.bookingServicesView.length && onlyPhysical;i++)
                    if  (bookingView.bookingServicesView[i].serviceView.nbHrsNeeded>0)
                        onlyPhysical = false;

            if (onlyPhysical) {
                for (let k = 0; k < this.aDayPrsView.length; k++)
                    hasAvailability = this.updateAvailabilityForADayPrView(bookingView,this.aDayPrsView[k]) || hasAvailability;
            } else {
                if (this.aDayHrsView.length==0)
                    return false;
                let aDayHrView = null;
                if (this.aView.selected.humanResourceView != null) {
                    aDayHrView = this.getDayHrView(this.aView.selected.humanResourceView)
                    hasAvailability = this.updateAvailabilityForADayHrView(bookingView,aDayHrView,true);
                } else {
                    for (let k = 0; k < this.aDayHrsView.length; k++) {
                        hasAvailability = this.updateAvailabilityForADayHrView(bookingView,this.aDayHrsView[k],false) || hasAvailability;
                    }
                }
            }


            //all timesView availables has been stored inside this.globalATimesView. Now need to put them inside this.aSlotsView;
            this.updateASlotsView(this.globalATimesView);

            return hasAvailability;
        }

        AvailableDayView.prototype.updateASlotsView = function(globalATimesView)  {
            //all timesView availables stored inside globalATimesView will be put inside this.aSlotsView;
            let periodTime;
            let aSlotView;
            //clear
            for (let p=0;p<this.aSlotsView.length;p++)
                this.aSlotsView[p].aTimesView = [];
            for (let t=0;t<globalATimesView.length;t++) {
                periodTime = globalATimesView[t].period.start.getTime();
                aSlotView = null;
                for (let s=0;s<this.aView.aSlotsRefView.length;s++) {
                    if (this.aView.aSlotsRefView[s].start.getTime()<=periodTime && this.aView.aSlotsRefView[s].end.getTime() > periodTime)
                        aSlotView = this.aSlotsView[s];
                }
                if (aSlotView)
                    aSlotView.aTimesView.push(globalATimesView[t]);
            }
        }

        AvailableDayView.prototype.updateAvailabilityForADayHrView = function(bookingView,aDayHrView,chooseHr) {
            let hasAvailability = false;
            if (bookingView
                    && bookingView.bookingServicesView.length > 0
                    && aDayHrView && aDayHrView.availablePeriods.length > 0
                    && aDayHrView.hrView) {
                let currentPeriod = new Period(aDayHrView.availablePeriods[0]); //init with first availability of DayHr
                currentPeriod.setDuration(this.aView.triesTime); //Will try every n minutes (App website parameter)
                let aPeriod;
                let index;
                let nbNotRoundedPeriod = 0;
                //when availability start at not a rounded time(rounded time minutes = 00/15/30/45) (ex : 10h20) -> propositions of reservations will be 10h20 10h35 10h45
                //nbNotRoundedPeriod allow to goback to a rounded time (10h45) after 2 propositions of not rounded time (10h20 10h35)
                //if not rounded init nbNotRoundedPeriod=1
                if (this.checkIfNotRoundedTime(currentPeriod.start)) {
                    nbNotRoundedPeriod++;
                }
                let tryNextTime = true;
                let maxLoop = 1000;
                do {
                    if (nbNotRoundedPeriod == 3) { //tried 2 times without rounded time (00/15/30/45)
                        currentPeriod = this.computePeriodFromMidnight(currentPeriod);
                    }

                    //Test if it's possible according the selected user
                    bookingView.moveToStart(currentPeriod.start);
                    aPeriod = aDayHrView.getAvailablePeriodByStart(bookingView.period.start);
                    if (aPeriod) {
                        if (bookingView.isBookable(this,chooseHr? aDayHrView : null)) {

                            //Need to check if it's available for PR and Secondaries
                            this.addPeriodToGlobalATimesViewHr(new Period(currentPeriod),aDayHrView.hrView);
                            hasAvailability = true;

                            currentPeriod.moveToStart(currentPeriod.end);
                            currentPeriod = this.computePeriodFromDayPlanningStartIfNeeded(currentPeriod);


                            if (nbNotRoundedPeriod!=0) {
                                nbNotRoundedPeriod++;
                            }
                        } else { //Not Available for HR

                            //adjust currentPeriod to start of next availablePeriods but need to test if this is the last available period or not
                            index = aDayHrView.availablePeriods.indexOf(aPeriod);
                            if (index != aDayHrView.availablePeriods.length-1) {//Not last

                                if (currentPeriod.end.getTime() < aDayHrView.availablePeriods[index+1].start.getTime()) {//not jump to next in case of multiple bookingsService

                                    currentPeriod.moveToStart(currentPeriod.end);
                                    if (nbNotRoundedPeriod!=0) {
                                        nbNotRoundedPeriod++ ;
                                    }
                                } else {
                                    currentPeriod.moveToStart(aDayHrView.availablePeriods[index + 1].start)
                                    if (this.aView.triesTime <= this.aView.triesTimeLimit) {
                                        nbNotRoundedPeriod = 1;
                                    }
                                }
                            } else  { //continue for manage multi
                                currentPeriod.moveToStart(currentPeriod.end);
                                if (nbNotRoundedPeriod!=0) {
                                    nbNotRoundedPeriod++ ;
                                }
                            }
                        }
                    } else {
                        aPeriod = aDayHrView.getNextAvailablePeriodByStart(bookingView.period.start);
                        if (aPeriod) { //start at next period
                            currentPeriod.moveToStart(aPeriod.start);
                            nbNotRoundedPeriod = 0;
                            if(this.checkIfNotRoundedTime(currentPeriod.start)) {
                                nbNotRoundedPeriod++;
                            }
                        } else {
                            currentPeriod.moveToStart(currentPeriod.end);
                            if (nbNotRoundedPeriod!=0) {
                                nbNotRoundedPeriod++ ;
                            }
                        }
                    }
                    if ((currentPeriod.end.getTime())>this.aView.aSlotsRefView[this.aView.aSlotsRefView.length-1].end.getTime()) {
                        tryNextTime = false;
                    }
                    maxLoop--;
                } while(tryNextTime && maxLoop>0)
            }
            return hasAvailability;
        }

        AvailableDayView.prototype.updateAvailabilityForADayPrView = function(bookingView,aDayPrView) {
            let hasAvailability = false;
            if (bookingView && bookingView.bookingServicesView.length > 0 && aDayPrView && aDayPrView.availablePeriods.length > 0 && aDayPrView.prView) {
                let currentPeriod = new Period(aDayPrView.availablePeriods[0]);   //init with first availability of DayPr
                currentPeriod.setDuration(this.aView.triesTime);//Will try every n minutes
                let aPeriod;
                let index;
                let nbNotRoundedPeriod = 0;
                //when availability start at not a rounded time (ex : 10h20) -> propositions of reservations will be 10h20 10h35 10h45
                //  nbNotRoundedPeriod allow to goback to a rounded time (10h45) after 2 propositions of not rounded time (10h20 10h35)
                if (this.checkIfNotRoundedTime(currentPeriod.start)) {
                    nbNotRoundedPeriod++;
                }

                let tryNextTime = true;
                let maxLoop = 1000;
                do {

                    if (nbNotRoundedPeriod == 3) { //tried 2 times a hours with some minutes of "decalage"
                        currentPeriod = this.computePeriodFromMidnight(currentPeriod);
                    }

                    //Test if it's possible according the selected user
                    bookingView.moveToStart(currentPeriod.start);
                    aPeriod = aDayPrView.getAvailablePeriodByStart(bookingView.period.start);
                    if (aPeriod) {
                        if (bookingView.isBookable(this, null)) { //Available for PR

                            this.addPeriodToGlobalATimesViewPr(new Period(currentPeriod), aDayPrView.prView);
                            hasAvailability = true;
                            //}
                            currentPeriod.moveToStart(currentPeriod.end);
                            currentPeriod = this.computePeriodFromDayPlanningStartIfNeeded(currentPeriod);
                            if (nbNotRoundedPeriod != 0) {
                                nbNotRoundedPeriod++;
                            }
                        } else { //Not Available for pr
                            //adjust currentPeriod to start of next availablePeriods but need to test if this is the last available period or not
                            index = aDayPrView.availablePeriods.indexOf(aPeriod);
                            if (index != aDayPrView.availablePeriods.length - 1) {//Not last

                                if (currentPeriod.end.getTime() < aDayPrView.availablePeriods[index + 1].start.getTime()) {//not jump to next in case of multiple bookingsService
                                    currentPeriod.moveToStart(currentPeriod.end);
                                    if (nbNotRoundedPeriod != 0)
                                        nbNotRoundedPeriod++;

                                } else {
                                    currentPeriod.moveToStart(aDayPrView.availablePeriods[index + 1].start);
                                    if (this.aView.triesTime <= this.aView.triesTimeLimit)
                                        nbNotRoundedPeriod = 1;
                                }
                            } else { //continue for manage multi
                                currentPeriod.moveToStart(currentPeriod.end);
                                if (nbNotRoundedPeriod != 0) {
                                    nbNotRoundedPeriod++;
                                }
                            }
                        }
                    } else {
                        aPeriod = aDayPrView.getNextAvailablePeriodByStart(bookingView.period.start);
                        if (aPeriod)   //start at next period
                        {
                            currentPeriod.moveToStart(aPeriod.start);
                            nbNotRoundedPeriod = 0;
                            if (this.checkIfNotRoundedTime(currentPeriod.start)) {
                                nbNotRoundedPeriod++;
                            }
                        } else {
                            currentPeriod.moveToStart(currentPeriod.end);
                            if (nbNotRoundedPeriod != 0)
                                nbNotRoundedPeriod++;
                        }
                    }
                    if ((currentPeriod.end.getTime()) > this.aView.aSlotsRefView[this.aView.aSlotsRefView.length - 1].end.getTime()) {
                        tryNextTime = false;
                    }
                    maxLoop--;
                }
                while (tryNextTime && maxLoop > 0)
            }
            return hasAvailability;
        }

        AvailableDayView.prototype.checkIfNotRoundedTime = function(time) {
            return this.aView.triesTime <= this.aView.triesTimeLimit
                    && time
                    && !Number.isInteger(time.getTime()/ this.ROUNDED_TIME_MINUTES);
        };

        AvailableDayView.prototype.computePeriodFromMidnight = function(currentPeriod) {
            let period = new Period(currentPeriod);
            period.start.setTime(Math.round(period.start.getTime() / this.aView.triesTime) * this.aView.triesTime);
            period.adjustEnd();
            return period;
        };

        AvailableDayView.prototype.computePeriodFromDayPlanningStartIfNeeded = function(currentPeriod) {
            let newPeriod = new Period(currentPeriod);
            if (this.aView.triesTime > this.aView.triesTimeLimit && this.aView.autoFilling) {
                newPeriod = this.computePeriodFromDayPlanningStart(newPeriod);
            }
            return newPeriod;
        };

        AvailableDayView.prototype.computePeriodFromDayPlanningStart = function(currentPeriod) {
            let newPeriod = new Period(currentPeriod);
            let timeFromDayStart = newPeriod.start.getTime() - this.aView.period.start.getTime();
            let rawSlotNumber = timeFromDayStart / this.aView.triesTime;
            let slotNumber = Math.floor(rawSlotNumber);
            let durationBeforeStartTime = slotNumber * this.aView.triesTime;
            let startTime = durationBeforeStartTime + this.aView.period.start.getTime();
            newPeriod.start.setTime(startTime);
            newPeriod.adjustEnd();

            return newPeriod;
        };

        AvailableDayView.prototype.setResourcesOnBooking = function(bookingView) {
            var bookable = false;
            if (this.aView.selected.aTimeView!=null && bookingView)
            {
                var aTimeView =   this.aView.selected.aTimeView;
                var hrView = null;
                if (aTimeView.hrsView && aTimeView.hrsView.length>0 && aTimeView.hrsView[0])
                    hrView = this.getDayHrView(aTimeView.hrsView[0]);

                if (hrView)
                    bookable = bookingView.isBookable(this, hrView);

                if (!bookable)
                    bookable =  bookingView.isBookable(this,this.aView.selected.humanResourceView);
            }
            return bookable;
        };

        AvailableDayView.prototype.getFirstAvailableDayRView = function(listADayRsView, bsView) {
            for (var k = 0; k < listADayRsView.length; k++) {
                if (listADayRsView[k].isAvailableForBookingServiceView(bsView))
                    return listADayRsView[k];
            }
            return null;
        };
        AvailableDayView.prototype.getDiscountDays = function()
        {
            var discountDay = {dayId : DaySrv.getIdFromDate(this.date),aSlotsView : []};

            for (var p=0;p<this.aSlotsView.length;p++)
                if (this.aSlotsView[p].discount!=0)
                    discountDay.aSlotsView.push({hour : this.aView.aSlotsRefView[p].start.hour,discount :this.aSlotsView[p].discount});
            return discountDay;
        };
        AvailableDayView.prototype.setByDiscountDays = function(discountDay)
        {
            this.hasDiscount = false;
            for (var i=0;i<discountDay.aSlotsView.length;i++)
                for (var p=0;p<this.aSlotsView.length;p++)
                    if  (this.aView.aSlotsRefView[p].start.hour==discountDay.aSlotsView[i].hour) {
                        this.aSlotsView[p].discount = Math.abs(discountDay.aSlotsView[i].discount);
                        if (this.aSlotsView[p].discount!=0)
                            this.hasDiscount = true;
                    }
        };
        AvailableDayView.prototype.updateDiscount = function(index,value)
        {
            this.aSlotsView[index].discount+=value;
            this.aView.domainView.updateDiscountDays();
        }
        return  AvailableDayView;
    }]);




// WEBPACK FOOTER //
// ./js/services/customerSite/views/AvailableDayView.js